export default __webpack_public_path__ + "2f1a4599da466914eac1ff441370bdfb.jpg";